export const fullName = ({ firstName = '', lastName = '' }) => {
  return `${firstName} ${lastName}`;
};

export const cityRegion = ({ city, region }) => {
  return `${city}, ${region}`;
};
